// CandidatesZone, French. Values identical to PeoplePage's own entries where they overlap.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Candidates': 'Candidats',
  'named by evidence, not on the record · promote or refuse in Review':
    'nommés par des preuves, hors dossier · à retenir ou refuser dans la revue',
  'Review': 'Revue',
  'loading…': 'chargement…',
  'The candidates could not be read: {error}': 'Les candidats n’ont pas pu être lus : {error}',
  'not on the record': 'hors dossier',
  'from the segment {name}': 'du segment {name}',
  'as Surfe returned it': 'tel que renvoyé par Surfe',
  'no source named': 'aucune source nommée',
  'Promote to person': 'Promouvoir en personne',
  'Holds {ref} and writes the row': 'Retient {ref} et écrit la ligne',
  'No proposal behind this row — its status is flipped directly':
    'Aucune proposition derrière cette ligne — son statut est basculé directement',
  'No candidate matches the search. {n} are waiting.':
    'Aucun candidat ne correspond à la recherche. {n} attendent.',
  'Nothing has proposed itself as a person. Candidates arrive from a lookalike run or a registry publication, and they stay off the record until you promote one.':
    'Rien ne s’est proposé comme personne. Les candidats viennent d’un passage de similarité ou d’une publication au registre, et restent hors dossier tant que vous n’en promouvez aucun.',
  '{name} is on the record. {ref} is held.': '{name} est au dossier. {ref} est retenue.',
  '{name} is on the record.': '{name} est au dossier.',
  'Could not promote this candidate.': 'Ce candidat n’a pas pu être promu.',

  // ── la colonne source ──
  'Source': 'Source',
  // 'research' seul est déjà le VERBE (le prochain geste de WhyNow) ; la colonne source nomme
  // un producteur, d'où sa propre clé de contexte.
  'research‖source': 'recherche',
  'a lookalike run against this segment persona named them':
    'une passe de similitude sur ce persona de segment l’a nommée',
  'the principal that filed the proposal': 'le mandant qui a déposé la proposition',
}, 'CandidatesZone');
